<script>
import AccuracyPrecisionCompletion from '../AccuracyPrecisionCompletion'

export default {
  name: 'AccuracyCompletion',
  extends: AccuracyPrecisionCompletion,
  getSelected: opt => `实测值:${opt.value}`,
  computed: {
    label: () => '准确度'
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Data/TaskResult/Completion/Formula/AccuracyCompletion.vue